import React from 'react';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';

const Pagination = ({ 
    currentPage, 
    totalPages, 
    onPageChange, 
    totalItems, 
    itemsPerPage, 
    onItemsPerPageChange,
    loading 
}) => {
    if (loading || totalItems === 0) return null;

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = currentPage * itemsPerPage;

    return (
        <div className="px-6 py-4 border-t border-gray-100 flex flex-col md:flex-row items-center justify-between bg-white gap-4">
            <div className="flex items-center gap-4">
                <div className="text-sm text-gray-500">
                    Mostrando <span className="font-medium text-gray-700">{indexOfFirstItem + 1}</span> - <span className="font-medium text-gray-700">{Math.min(indexOfLastItem, totalItems)}</span> de <span className="font-medium text-gray-700">{totalItems}</span> resultados
                </div>
                
                {onItemsPerPageChange && (
                    <div className="flex items-center gap-2">
                        <span className="text-xs text-gray-400 uppercase font-semibold">Mostrar:</span>
                        <select 
                            value={itemsPerPage}
                            onChange={(e) => onItemsPerPageChange(Number(e.target.value))}
                            className="text-sm border border-gray-200 rounded px-2 py-1 outline-none focus:border-blue-500 transition-colors bg-gray-50 font-medium"
                        >
                            {[5, 10, 25, 50, 100].map(val => (
                                <option key={val} value={val}>{val}</option>
                            ))}
                        </select>
                    </div>
                )}
            </div>

            <div className="flex items-center space-x-1">
                {/* First Page */}
                <button
                    onClick={() => onPageChange(1)}
                    disabled={currentPage === 1}
                    className="p-2 rounded-md hover:bg-gray-100 disabled:opacity-30 disabled:cursor-not-allowed transition-colors text-gray-600"
                    title="Primera página"
                >
                    <ChevronsLeft className="w-4 h-4" />
                </button>

                {/* Previous Button */}
                <button
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    className="flex items-center gap-1 p-2 rounded-md hover:bg-gray-100 disabled:opacity-30 disabled:cursor-not-allowed transition-colors text-gray-600"
                >
                    <ChevronLeft className="w-4 h-4" />
                </button>
                
                <div className="flex items-center mx-2 gap-1">
                    {Array.from({ length: totalPages }, (_, i) => i + 1)
                        .filter(page => Math.abs(page - currentPage) <= 1 || page === 1 || page === totalPages)
                        .map((page, index, array) => {
                            const addEllipsis = index > 0 && page - array[index - 1] > 1;
                            return (
                                <React.Fragment key={page}>
                                    {addEllipsis && <span className="text-gray-400 px-1">...</span>}
                                    <button
                                        onClick={() => onPageChange(page)}
                                        className={`w-8 h-8 flex items-center justify-center rounded-md text-sm font-bold transition-all ${
                                            currentPage === page
                                                ? 'bg-blue-600 text-white shadow-md transform scale-110'
                                                : 'text-gray-600 hover:bg-gray-100'
                                        }`}
                                    >
                                        {page}
                                    </button>
                                </React.Fragment>
                            );
                        })
                    }
                </div>

                {/* Next Button */}
                <button
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className="flex items-center gap-1 p-2 rounded-md hover:bg-gray-100 disabled:opacity-30 disabled:cursor-not-allowed transition-colors text-gray-600"
                >
                    <ChevronRight className="w-4 h-4" />
                </button>

                {/* Last Page */}
                <button
                    onClick={() => onPageChange(totalPages)}
                    disabled={currentPage === totalPages}
                    className="p-2 rounded-md hover:bg-gray-100 disabled:opacity-30 disabled:cursor-not-allowed transition-colors text-gray-600"
                    title="Última página"
                >
                    <ChevronsRight className="w-4 h-4" />
                </button>
            </div>
        </div>
    );
};

export default Pagination;
